import API from './axios/API';

export const riderOrderCancel = (deliveryService, orderId, service) => {
    return async (dispatch, getState) => {
        let response;

        try {
            if (deliveryService === 'adlogs') {
                const serviceQuery = service ? `?service=${service}` : '';
                response = await API.post(`/restaurants/:restaurantId/${deliveryService}/cancel-order${serviceQuery}`, {
                    order_id: orderId,
                    reason: 'Changed my mind'
                });
            } else {
                response = await API.post(`/restaurants/:restaurantId/${deliveryService}/cancel-order`, {
                    orderId: orderId,
                    cancellation_reason: 'customer cancel',
                });
            }
        } catch (error) {
            response = error;
        }

        return response;
    };
};

export const riderOrderCancelFlashAndHlDedicated = (deliveryService, orderId) => {
    return async (dispatch, getState) => {
        let response;

        try {
            response = await API.post(`/restaurants/:restaurantId/${deliveryService}/cancel-order`, {
                order_id: orderId,
            });
        } catch (error) {
            response = error;
        }

        return response;
    };
};
